module.exports = __webpack_public_path__ + "img/bind-collaborate-icon.7bb3e58a.png";